const requestVariableSettings = {
  label: 'Request Variable',
  name: 'config',
  helper: 'Enter the request variable that will store the signal payload',
};

export default requestVariableSettings;
